import styled from 'styled-components';
import { UIElements } from '@ansvar-sakerhet/ui';

const Table = styled.table`
  width: 100%;
  margin-top: 24px;
  border-collapse: collapse;
`;

const Th = styled.th`
  text-align: left;
  font-weight: 600;
  padding: 8px 12px;
  border-bottom: 2px solid ${({ theme }) => theme.colors.gray};
`;

const Td = styled.td`
  padding: 10px 12px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray};
  vertical-align: middle;
  word-break: break-word;
`;

const IconButton = styled.button`
  display: flex;
  align-items: center;
  border: none;
  padding: 0;
  background: none;
  cursor: pointer;
`;

export const S = {
  ...UIElements,
  Table,
  Th,
  Td,
  IconButton,
};
